<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="documentos"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
        </v-toolbar>
      </template>
      <template v-slot:item.proprietario.id="{ item }">
        <div class="caption text--disabled">
          {{ item.proprietario[item.tipo_proprietario.campo_codigo] }} ({{
            item.tipo_proprietario.descricao
          }})
        </div>
        <div>
          {{ item.proprietario[item.tipo_proprietario.campo_titulo] }}
        </div>
      </template>
      <template v-slot:item.data_validade="{ item }">
        <vencimento-documento :documento="item" :two-line="true" />
      </template>
      <template v-slot:item.registro="{ item }">
        <div class="d-flex align-center">
          <v-btn icon class="mr-2" @click="download(item)">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <div>
            <div class="caption text--disabled">
              {{ item.tipo_documento.descricao }}
            </div>
            <div>
              {{ item.registro }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small :to="rota(item)" target="_blank">
          <v-icon class="mdi mdi-open-in-new" small />
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import DatatableFilters from "../components/DatatableFilters";
import VencimentoDocumento from "../components/documentos/VencimentoDocumento";
export default {
  components: { DatatableFilters, VencimentoDocumento },
  data() {
    return {
      headers: [
        { text: "Proprietário", value: "proprietario.id" },
        { text: "Documento", value: "registro" },
        { text: "Vencimento", value: "data_validade", align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "tipos_proprietario",
          label: "Tipo de proprietário",
          type: "select",
          multiple: true,
          options: [],
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.relatorio_vencimento_documento") || "{}"
      ),
      loading: true,
      documentos: [],
    };
  },
  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
      usuarioAtivo: (state) => state.usuarios.usuarioAtivo,
    }),
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("permissao/deletar", id);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    editar(id) {
      this.$router.push({
        name: "permissoes-formulario-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;
      try {
        const filtros = _.clone(this.filtrosAtivos);
        if (!this.perms.includes("documentos.relatorio_vencimentos_total")) {
          filtros.responsaveis = [this.usuarioAtivo.id];
        } else if (filtros.responsaveis) {
          filtros.responsaveis = [filtros.responsaveis];
        }
        this.documentos = await this.$store.dispatch(
          "documento/relatorioVencimento",
          filtros
        );
      } catch (e) {
        console.log(e);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar o relatório",
        });
      }
      this.loading = false;
    },
    async download(doc) {
      try {
        const response = await this.$store.dispatch("documento/download", {
          urlBase: doc.tipo_proprietario.url_pesquisa.substr(1),
          doc,
        });
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (e) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível realizar o download do arquivo",
        });
      }
    },
    rota(doc) {
      const route = { params: { id: doc.id_proprietario } };
      switch (doc.tipo_proprietario.servico) {
        case "d3v-empresas-svc":
          route.name = "empresas-formulario-editar";
          break;
        case "d3v-funcionarios-svc":
          route.name = "funcionario-formulario-editar";
          break;
        case "d3v-vendedores-svc":
          route.name = "vendedor-formulario-editar";
          break;
        case "d3v-clientes-svc":
          route.name = "cliente-formulario-editar";
          break;
        case "d3v-ordemmedicao-svc":
          route.name = "ordem-medicao-formulario-editar";
          break;
        case "d3v-equipamento-svc":
          route.name = "equipamento-formulario-editar";
          break;
      }
      return route;
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem(
        "filtros.relatorio_vencimento_documento",
        JSON.stringify(val)
      );
      this.listar();
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Relatório de vencimento de documentos",
    });
    const vm = this;
    if (this.perms.includes("documentos.relatorio_vencimentos_total")) {
      this.filters.push({
        name: "responsaveis",
        label: "Usuário responsável",
        type: "select",
        multiple: false,
        options: [],
      });

      this.$store
        .dispatch("usuarios/listar", { filtros: { ativo: true } })
        .then((response) => {
          vm.filters.find(
            (f) => f.name === "responsaveis"
          ).options = response.data.map((u) => ({
            text: u.nome,
            value: u.id,
          }));
        });
    }

    this.$store
      .dispatch("documento/listarTiposProprietario")
      .then((proprietarios) => {
        vm.filters.find(
          (f) => f.name === "tipos_proprietario"
        ).options = proprietarios
          .filter((p) => {
            if (vm.perms.includes("documentos.relatorio_vencimentos_total")) {
              return true;
            }

            return p.responsaveis.find(
              (r) => r.id_usuario === vm.usuarioAtivo.id
            );
          })
          .map((p) => ({
            text: p.descricao,
            value: p.id,
          }));
      });
    this.listar();
  },
};
</script>
